import { FormattedMessage } from '@flipster/i18n';
import { Badge, BadgeProps } from '@flipster/react/design-system/badge';
import CrownIcon from '@flipster/react/icon/generated/CrownIcon';
import { getOrdinalNumber } from '@flipster/utils/num';

const maxRank = 500;

type Range = 'high' | 'mid' | 'low';
const getRange = (rank: number): Range => {
  if (1 <= rank && rank <= 10) return 'high';
  if (11 <= rank && rank <= 100) return 'mid';
  return 'low';
};

interface ProfileRankBadgeProps {
  rank: number;
}
export const ProfileRankBadge = ({ rank: _rank }: ProfileRankBadgeProps) => {
  const { number: rank, suffix } = getOrdinalNumber(_rank);

  const range = getRange(_rank);
  const badgeProps: Record<Range, BadgeProps> = {
    high: {
      type: 'tint',
      color: 'promotion',
    },
    mid: {
      type: 'tint',
      color: 'accent',
    },
    low: {
      type: 'tint',
      color: 'neutral',
    },
  };

  if (_rank > maxRank) return null;
  return (
    <Badge leadingIcon={<CrownIcon />} {...badgeProps[range]}>
      <FormattedMessage
        id='Autogen_common.r251126.s_PnL_rank_suffix'
        values={{
          rank: rank,
          suffix: suffix,
        }}
      />
    </Badge>
  );
};
